import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { CookieService } from 'ngx-cookie-service';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { TermsAndConditionService } from 'src/app/views/administration/terms-conditions/terms-conditions.service';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-user-terms-conditions',
  templateUrl: './user-terms-conditions.component.html',
  styleUrls: ['./user-terms-conditions.component.css']
})
export class UserTermsConditionsComponent  implements OnInit {

  @Input() isVisible: boolean = false;
  @Input() userId:number | null = null;
  @Input() fullName:string | null = null;
  @Input() userRole:string | null = 'Owner';


  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onTermsAccepted = new EventEmitter<any>();

  showTermsSuccessPopup: boolean = false;

  uploadedFiles: { file: File; name: string; size: number; displaySize: string, dataUrl?: string}[] = []; //from form
  userFullName = ''; //from form

  // userId: number | null = null;

  dragActive = false;

  pdfZoom: number = 1;
  Math = Math;

  termsContent: string = `
  <h2>Terms and Conditions for Use of the VSMPS Portal (Marine Procurement System)</h2>
  <p><strong>Last Updated:</strong> 23/03/2026</p>

  <p>
    These Terms and Conditions (“Agreement”) govern the use of the VSMPS Portal (Marine Procurement System)
    provided by <strong>Varuna Sentinels B.V.</strong>. By accessing or using the VSMPS Portal, you, the user, (“Buyer” or “Supplier”) agree to comply with and be bound by the terms outlined herein.
  </p>

  <h3>1. Definitions</h3>
  <p><strong>1.1 VSMPS Portal:</strong> The Marine Procurement System provided by Varuna Sentinels B.V., which facilitates the entire procurement process, from sending requests (e.g., RFQs) to the delivery of goods and services. The portal allows Buyers to submit requests, receive quotes from Suppliers, issue purchase orders, and track the fulfillment of those orders.</p>
  <p><strong>1.2 Supplier:</strong> Any business or individual who offers goods and/or services on the VSMPS Portal for purchase by Buyers.</p>
  <p><strong>1.3 Buyer:</strong> Any business or individual who purchases goods and/or services through the VSMPS Portal, either through requests, receiving quotes, and completing purchase orders.</p>
  <p><strong>1.4 Company or Varuna Sentinels B.V:</strong> The administrator and service provider of the VSMPS Portal, offering access and support for transactions but not directly involved in the execution of these transactions.</p>
  <p><strong>1.5 Transaction:</strong> Any purchase or sale agreement made on the VSMPS Portal, including the submission of requests, receiving and agreeing on quotes, issuing purchase orders, invoicing, and payment.</p>

  <h3>2. Platform Usage</h3>
  <p><strong>2.1 Purpose:</strong> The VSMPS Portal facilitates the full procurement process. It enables Buyers to send requests for goods or services, receive quotes from Suppliers, issue purchase orders, and track delivery of the goods or services.</p>
  <p><strong>2.2 No Direct Involvement:</strong> Varuna Sentinels B.V. does not participate in the negotiation, pricing, or fulfillment of transactions between Buyers and Suppliers, nor in any disputes that arise. Varuna Sentinels B.V. solely provides the platform for these activities.</p>

  <h3>3. Roles and Responsibilities</h3>

  <h4>3.1 Company Responsibilities</h4>
  <ul>
    <li>Portal administration and maintenance: Varuna Sentinels B.V. is responsible for providing and maintaining the VSMPS Portal and ensuring its functionality for procurement transactions.</li>
    <li>Technical support: The Company will offer support for accessing and using the VSMPS Portal, including assistance with transactions.</li>
    <li>Data privacy compliance: Varuna Sentinels B.V. will ensure that user data is handled in compliance with applicable privacy laws, including GDPR. The Company will take reasonable measures to protect the platform from unauthorized access and data breaches.</li>
    <li>No role in transactions: Varuna Sentinels B.V. does not participate in the terms or execution of any purchase order, sale, or delivery made through the VSMPS Portal.</li>
  </ul>

  <h4>3.2 Supplier Responsibilities</h4>
  <ul>
    <li>Product Listings: Suppliers are responsible for providing accurate and detailed product descriptions, pricing, and availability for goods and services listed on the VSMPS Portal.</li>
    <li>Contractual Fulfillment: Suppliers must ensure they fulfill the terms of any transaction agreed upon with the Buyer, including product delivery, quality assurance, and compliance with relevant regulations.</li>
    <li>Liability for Transactions: Suppliers agree to indemnify and hold harmless Varuna Sentinels B.V. from any claims, losses, or damages arising from the sale, delivery, or fulfillment of their products and services.</li>
  </ul>

  <h4>3.3 Buyer Responsibilities</h4>
  <ul>
    <li>Request Submission and Payment: Buyers are responsible for submitting accurate requests and ensuring that the necessary product/service specifications and requirements are included. They must also make timely payments for goods and services ordered.</li>
    <li>Reviewing Quotes: Buyers must carefully review quotes provided by Suppliers before proceeding with purchase orders.</li>
    <li>Product Acceptance: Upon receiving goods and services, Buyers must inspect them and notify the Supplier of any defects or issues as per the Supplier's return or complaint policy.</li>
    <li>Liability for Transactions: Buyers agree to indemnify and hold harmless Varuna Sentinels B.V. from any claims or damages arising from the procurement of goods or services via the VSMPS Portal, including failure to pay for goods, disputes over product quality, or delivery issues.</li>
  </ul>

  <h3>4. Procurement Process</h3>
  <ol>
    <li>Initiation of Requests: Buyers can submit requests for products or services through the VSMPS Portal. The request will include detailed specifications and requirements for the product or service needed.</li>
    <li>Supplier Response: Suppliers will receive the requests and are responsible for submitting detailed, accurate, and timely quotes. Quotes must specify the pricing, delivery time, payment terms, and any other relevant conditions.</li>
    <li>Purchase Order: Once an agreement is reached, the Buyer will issue a purchase order based on the agreed quote, which will then lead to invoicing and payment.</li>
    <li>Completion of Transaction: Upon receipt of the goods or services, the Buyer must inspect them and accept or reject the delivery based on the Supplier’s terms.</li>
  </ol>

  <h3>5. Limitation of Liability</h3>
  <p>Exclusion of Liability for Transactions: Varuna Sentinels B.V. is not responsible for any loss, damage, or dispute arising from requests, quotes, purchase orders, product delivery, payment issues, or any other part of the transaction process conducted via the VSMPS Portal.</p>
  <p>No Guarantee of Transaction Success: Varuna Sentinels B.V. does not guarantee the successful completion of any transaction between Buyers and Suppliers.</p>

  <h3>6. Governing Law</h3>
  <p>Applicable Law: This Agreement and all transactions carried out on the VSMPS Portal are governed by the laws of the Netherlands.</p>
  <p>Jurisdiction: Any disputes arising out of or in connection with this Agreement shall be subject to the exclusive jurisdiction of the courts in the Netherlands.</p>

  <h3>7. Amendments</h3>
  <p>Right to Modify: Varuna Sentinels B.V. reserves the right to amend, modify, or update these Terms and Conditions at any time. All amendments will be communicated to users via email or within the VSMPS Portal.</p>

  <hr/>

  <h2>Terms and Conditions for Use of the VSMPS Marketplace</h2>
  <p><strong>Last Updated:</strong> 23/03/2026</p>

  <h3>1. Definitions</h3>
  <p><strong>Marketplace:</strong>The Marketplace is a part of the VSMPS Portal where Suppliers list their products for sale, and Buyers browse and make purchases directly.</p>
  <p><strong>Supplier:</strong> Any business or individual who offers goods listed for purchase on the Marketplace.</p>
  <p><strong>Buyer:</strong> Any business or individual who purchases goods via the Marketplace.</p>

  <h3>2. Platform Usage</h3>
  <p>Purpose of the Marketplace: The Marketplace allows Buyers to browse products and services listed by Suppliers and make direct purchases.</p>
  <p>No Direct Involvement in Transactions: Varuna Sentinels B.V. does not take part in the actual transaction, including pricing or fulfilment of orders.</p>

  <h3>3. Roles and Responsibilities</h3>

  <h4>Varuna Sentinels B.V.'s Responsibilities:</h4>
  <ul>
    <li>Marketplace Administration: Varuna Sentinels B.V. is responsible for providing and maintaining the Marketplace.</li>
    <li>Facilitation of Transactions: Varuna Sentinels B.V. facilitates the transaction process but does not directly handle payments or delivery.</li>
  </ul>

  <h4>Suppliers' Responsibilities</h4>
  <ul>
    <li>Product Listings: Suppliers must ensure that product descriptions, pricing, and availability are accurate and up-to-date on the Marketplace.</li>
    <li>Fulfillment of Transactions: Suppliers must deliver goods according to the terms agreed with the Buyer, including shipping, delivery timelines, and invoicing.</li>
    <li>Liability for Transactions: Suppliers agree to indemnify and hold harmless Varuna Sentinels B.V. from any claims, losses, or damages arising from the goods or services sold.</li>

  </ul>

  <h4>Buyers' Responsibilities:</h4>
  <ul>
    <li>Browsing and Purchasing: Buyers are responsible for browsing the Marketplace and placing orders with Suppliers for goods.</li>
    <li>Payment for Goods and Services: Buyers must ensure that payments for products ordered are completed in a timely manner.</li>
    <li>Product Acceptance: Upon receiving products, Buyers must inspect them and notify the Supplier of any defects or issues as per the Supplier’s return or complaint policy.</li>
  </ul>

  <h3>4. Marketplace Flow</h3>
  <ol>
    <li>Product Listings: Suppliers list products in the Marketplace.</li>
    <li>Buyer Interaction: Buyers browse and select products they wish to purchase and proceed with placing orders directly with Suppliers.</li>
    <li>Purchase Orders and Payment: The Buyer confirms the order and proceeds to payment, which is facilitated by Varuna Sentinels B.V., although Varuna Sentinels B.V. is not responsible for the payment process itself.</li>
    <li>Supplier Fulfillment: Suppliers are responsible for fulfilling the orders, including delivery and invoicing according to the agreed terms.</li>
    <li>Completion of Transaction: Upon receiving the products, the Buyer must inspect and accept them in accordance with the Supplier's policies.</li>

  </ol>

  <h3>5. Limitation of Liability</h3>
  <p>Exclusion of Liability for Transactions: Varuna Sentinels B.V. is not responsible for any loss, damage, or dispute arising from Marketplace transactions, including issues related to product delivery, quality, or payment.</p>

  <h3>6. Governing Law</h3>
  <p>Applicable Law: This Agreement and all transactions carried out on the Marketplace are governed by the laws of the Netherlands.</p>
  <p>Jurisdiction: Disputes will be subject to the exclusive jurisdiction of the courts in the Netherlands.</p>


  <h3>7. Amendments to the Terms and Conditions</h3>
  <p>Right to Modify: Varuna Sentinels B.V. reserves the right to amend, modify, or update these Terms and Conditions at any time. All amendments will be communicated to users via email or within the VSMPS Portal.</p>
`;

 supplierTermsUrl = 'https://vsmps-assets-dev.s3.eu-west-1.amazonaws.com/terms-conditions/VSMPS_Supplier_TC_v1.0.pdf';
 buyerTermsUrl = 'https://vsmps-assets-dev.s3.eu-west-1.amazonaws.com/terms-conditions/VSMPS_Buyer_TC_v1.0.pdf'



  termsResponse:any
  currentDate= new Date().toISOString().split('T')[0];

  constructor(
    private awsSdkService: AwsSdkService,
    private webApiService: WebApiService,
    private cookieService: CookieService,
    private fullLoaderService: FullLoaderService,
    private termsAndConditionService:TermsAndConditionService,
    private snack: MatSnackBar,
    private sanitizer: DomSanitizer

  ) {



  }


  ngOnInit(): void {
  }

  closeModals(): void {
    this.isVisible = false;
    this.visibleChange.emit(this.isVisible);
  }

  zoomIn(): void {
    if (this.pdfZoom < 2) {
      this.pdfZoom = Math.round((this.pdfZoom + 0.1) * 10) / 10;
    }
  }

  zoomOut(): void {
    if (this.pdfZoom > 0.5) {
      this.pdfZoom = Math.round((this.pdfZoom - 0.1) * 10) / 10;
    }
  }

  resetZoom(): void {
    this.pdfZoom = 1;
  }


  async downloadAttachment(name: string): Promise<void> {
    // const ticket = this.selectedTicket;
    // if (!ticket || !ticket.attachments?.length) {
    //   console.warn('No attachments available to download.');
    //   return;
    // }
    // const attachment = ticket.attachments.find((a) => a.name === name) || ticket.attachments[0];
    // await this.triggerAttachmentDownload(attachment);
  }

  triggerFileBrowse(input: HTMLInputElement): void {
    input.click();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragActive = true;
  }

  onDragLeave(): void {
    this.dragActive = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragActive = false;
    if (event.dataTransfer?.files) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  onFileChange(event: Event): void {
    const files = (event.target as HTMLInputElement).files;
    this.handleFiles(files);
    (event.target as HTMLInputElement).value = '';
  }

  removeFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
  }

  private handleFiles(files: FileList | null): void {
    if (!files) {
      return;
    }

    Array.from(files).forEach((file) => {
      const allowedTypes = ['image/jpeg', 'image/png'];
  
      if (!allowedTypes.includes(file.type)) {
        this.snack.open(`Only JPG, JPEG, and PNG files are allowed.`, 'OK', { duration: 3000, panelClass: 'custom-snack' });
        return;
      }
  
      const reader = new FileReader();
  
      reader.onload = (e: any) => {
        this.uploadedFiles.push({
          file,
          name: file.name,
          size: file.size,
          displaySize: this.formatFileSize(file.size),
          dataUrl: e.target.result 
        });
      };
  
      reader.readAsDataURL(file); 
    });
  }

  private formatFileSize(bytes: number): string {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  async acceptTerms(): Promise<void> {
    const missing: string[] = [];
    if (!this.userFullName.trim()) missing.push('Full Name');
    if (!this.userId) missing.push('User Info');
    if (!this.uploadedFiles.length) missing.push('Signature');

    if (missing.length) {
      this.snack.open(`Missing fields: ${missing.join(', ')}`, 'OK', { duration: 3000, panelClass: 'custom-snack' });
      return;
    }

    // if(this.fullName !== this.userFullName){
    //   this.snack.open(`Full Name does not match`, 'OK', { duration: 3000, panelClass: 'custom-snack' });
    //   return;
    // }

    if(this.uploadedFiles.length > 1){
      this.snack.open(`More than one signature file`, 'OK', { duration: 3000, panelClass: 'custom-snack' });
      return;
    }

    this.fullLoaderService.showLoader();

    try {
      const documentDetails = await this.uploadAttachmentsToS3();


      const backendPayload = {
        userId: this.userId,
        userFullName: this.userFullName || '',
        termsAccepted: 1,
        termsVersion: 1,
        singatureS3path: documentDetails?.[0]?.s3path || null
      };

      const response = await this.termsAndConditionService.acceptTermsAndConditions(backendPayload);

      this.fullLoaderService.hideLoader();
    
      console.log(response,'response from terms')

      this.termsResponse = response.result

      if(response.result.termsAccepted){
        this.isVisible = false;
        this.visibleChange.emit(false);
        this.showTermsSuccessPopup = true
      }

      

      // if (this.cookieService.check('isTermsAccepted')) {
      //   this.cookieService.delete('isTermsAccepted');
      // }

      // this.cookieService.set('isTermsAccepted', response.result.termsAccepted ,1,  '/' , '', true, 'Lax') 




    } catch (err) {
      console.error('Failed to submit support ticket', err);
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }


  private async uploadAttachmentsToS3(): Promise<{ documentName: string; documentType: string; s3path: string }[]> {
    const uploads: { documentName: string; documentType: string; s3path: string }[] = [];

    for (const item of this.uploadedFiles) {
      const detail = {
        documentName: item.name,
        documentType: item.file.type || '',
        s3path: ''
      };

      const key = `user/signature/${Date.now()}-${Math.random().toString(36).slice(2)}-${item.name}`;
      const s3Params = { fileKey: key, fileContentType: item.file.type || 'application/octet-stream' };

      try {
        const signedUrl = await this.awsSdkService.getSignedUrlPromise(s3Params);
        await this.webApiService.putRequestExternalApi(signedUrl, item.file);
        detail.s3path = this.awsSdkService.extractS3LocationFromUrl(signedUrl);
      } catch (err) {
        console.error('Failed to upload attachment to S3', item.name, err);
      }

      uploads.push(detail);
    }

    return uploads;
  }

  proceed(){
    console.log('clicked proceed')
    console.log(this.termsResponse) 
    this.showTermsSuccessPopup = false
    this.onTermsAccepted.emit(this.termsResponse);
  }
}
